import React from "react";

import { IconButton, Tooltip } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import { MdOutlineScreenShare, MdOutlineStopScreenShare } from "react-icons/md";

import useVideoContext from "../../hooks/useVideoContext/useVideoContext";

export const SCREEN_SHARE_TEXT = "Share Screen";
export const STOP_SCREEN_SHARE_TEXT = "Stop Sharing Screen";
export const SHARE_IN_PROGRESS_TEXT = "Cannot share screen when another user is sharing";
export const SHARE_NOT_SUPPORTED_TEXT = "Screen sharing is not supported with this browser";

const useStyles = makeStyles(() =>
  createStyles({
    iconButton: {
      padding: 0,
      marginLeft: "0.7rem",
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:disabled": {
        opacity: 0.8,
      },
    },
    iconPointer: {
      cursor: "pointer",
    },
  })
);

export default function ToggleScreenShareButton(props: { disabled?: boolean }) {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { isSharingScreen, toggleScreenShare, room, participantsAllowed } = useVideoContext();

  const isScreenShareSupported = navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia;

  const isDisabled =
    props.disabled || !isScreenShareSupported || !room || participantsAllowed?.length === 0;

  let tooltipMessage = "";

  if (isSharingScreen) {
    tooltipMessage = translate("stopSharingScreen");
  }

  if (!isSharingScreen) {
    tooltipMessage = translate("shareScreen");
  }

  const renderIcons = () => {
    if (isSharingScreen)
      return <MdOutlineStopScreenShare size={20} color="#475467" className={classes.iconPointer} />;

    return <MdOutlineScreenShare size={20} color="#475467" className={classes.iconPointer} />;
  };

  return (
    <Tooltip title={tooltipMessage}>
      <span>
        {/* The span element is needed because a disabled button will not emit hover events and we want to display
          a tooltip when screen sharing is disabled */}
        <IconButton
          className={classes.iconButton}
          onClick={toggleScreenShare}
          disabled={isDisabled}
          data-cy="videoSurveyScreenShareIcon"
          data-cy-share-screen
        >
          {renderIcons()}
        </IconButton>
      </span>
    </Tooltip>
  );
}
